import { Component, OnInit, inject } from '@angular/core';
import {
  UntypedFormGroup,
  FormGroup,
  FormControl,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { InvestmentWizardService } from '../investment-wizard/services/investment-wizard-service.service';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-family-dialog',
  templateUrl: './family-dialog.component.html',
  styleUrls: ['./family-dialog.component.scss'],
  imports: [
    ReactiveFormsModule,
    MatDialogModule,
    MatSelectModule,
    MatButtonModule,
  ],
})
export class FamilyDialogComponent implements OnInit {
  dialogRef = inject<MatDialogRef<FamilyDialogComponent>>(MatDialogRef);
  private iws = inject(InvestmentWizardService);
  data = inject(MAT_DIALOG_DATA);

  form: FormGroup;
  headline: string;
  content: string;
  confirm: string;
  fundFamilies;

  constructor() {
    const data = this.data;

    const formGroup = {};
    formGroup['family'] = new FormControl();
    this.form = new UntypedFormGroup(formGroup);
    if (data) {
      this.headline = data.headline || 'Please Select a Fund Family';
      this.content = data.content || '';
      this.confirm = data.confirm || 'Save';
    }
  }

  ngOnInit() {
    this.iws.fundFamilyList(this.data.program).subscribe(({ results }) => {
      this.fundFamilies = results;
    });
  }

  cancel() {
    this.dialogRef.close({ data: 'cancel' });
  }

  save() {
    if (this.form.valid) {
      this.dialogRef.close({ data: this.form.get('family').value });
      this.dialogRef.afterClosed().subscribe(() => {
        this.dialogRef = null;
      });
    }
  }
}
